import type { FuelType } from "@/types/fareCalculation";
import type { VehicleMake, VehicleModel } from "@/services/vehicleService";

export const MIN_SEATS = 1;
export const MAX_SEATS = 9;
/** Default number of seats the host offers to share. */
export const DEFAULT_OFFERING_SEATS = 4;

/**
 * Max seats a host can offer for a given vehicle capacity. One seat is always the
 * driver's, so offering is capped at availableSeats - 1.
 */
export function maxOfferingSeats(availableSeats: number | null): number {
  if (availableSeats == null) return MAX_SEATS;
  return Math.max(MIN_SEATS, Math.min(MAX_SEATS, availableSeats - 1));
}
export const FUEL_TYPES: FuelType[] = ["Petrol", "Diesel", "Electric", "Hybrid"];

export const DEFAULT_VEHICLE_MAKE = "Honda";
export const DEFAULT_VEHICLE_MODEL = "City";

/** Total seats available in the vehicle (capacity). */
export const MIN_AVAILABLE_SEATS = 1;
export const MAX_AVAILABLE_SEATS = 10;
/** Initial capacity shown before the user picks a different make. */
export const DEFAULT_AVAILABLE_SEATS = 5;

export function findVehicleMakeByName(
  makes: VehicleMake[],
  name: string
): VehicleMake | undefined {
  const target = name.trim().toLowerCase();
  return makes.find((make) => make.maNa.trim().toLowerCase() === target);
}

export function findVehicleModelByName(
  models: VehicleModel[],
  name: string
): VehicleModel | undefined {
  const target = name.trim().toLowerCase();
  return (
    models.find((model) => model.moNa.trim().toLowerCase() === target) ??
    models.find((model) => model.moNa.trim().toLowerCase().startsWith(target))
  );
}
